<h1 class="page-title">Browse Users</h1>
<section class="widget">
  <div class="widget-body">
    <div class="mt">
      <form novalidate>
        <div class="row">
            <div class="col-md-4 col-sm-6">
                <!--search string-->
                <label class="header-label">Search:</label>
                <div class="search-input-wrap">
                  <input class="form-control"
                         type="text"
                         [(ngModel)]="searchString"
                         [ngModelOptions]="{standalone: true}"
                         placeholder="Name, Email or Username"
                         [disabled]="!isSystemAdmin()"/>
                  <button *ngIf="searchString && isSystemAdmin()"
                          type="button"
                          class="search-clear-btn"
                          (click)="clearSearch()"
                          aria-label="Clear search">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
            </div>
          <div class="col-md-4 col-sm-6">
            <!--search string-->
            <label class="header-label">Agency:</label>
            <input class="form-control"
                   type="text"
                   [value]="agencySearchValue"
                   placeholder="Select an Agency"
                   (click)="showAgencyModal()"
                   (keydown)="showAgencyModal()"
                   [disabled]="!isSystemAdmin()"/>
          </div>
          <div class="col-md-4 col-sm-3">
            <!--User Type filter-->
            <label class="header-label">User Type:</label>
            <dropdown [promptValue]="'User Types'"
                      [values]="userTypeDropdown"
                      (select)="selectUserType($event)"></dropdown>
          </div>
        </div>
          <div class="display-flex mt-2">
              <div class="display-flex">
                  <label class="form-check">
                      <input class="form-check-input"
                             [(ngModel)]="includeDisabled"
                             [ngModelOptions]="{standalone: true}"
                             type="checkbox">
                      <span class="form-check-label">Show Disabled</span>
                  </label>
              </div>
          </div>
        <div class="row mt-1">
          <div class="col-md-3 col-sm-3">
            <button class="btn btn-primary width-100 mb-xs me-2" type="submit" role="button"
                    (click)="searchUsers()">Search
            </button>
            <a class="btn btn-primary mb-xs" *ngIf="isSystemAdmin()" [href]="downloadUsers()">Download List</a>
          </div>
          <div class="col-md-9 col-sm-9">
            <button class="btn btn-primary width-100 mb-xs button-right" [routerLink]="['../user/add']">New
              User
            </button>
          </div>
        </div>
      </form>

      <table-dynamic id="datatable-table"
                     class="table table-striped table-hover"
                     [headers]="tableHeaders"
                     [currentPage]="currentPage"
                     [totalCount]="totalCount"
                     (headerClick)="sortUsers($event)"
                     (pageChanged)="setPage($event)"
                     (limitChange)="setLimit($event)">
        <tr *ngFor="let user of pagedUsers?.items">
          <td>
            <a *ngIf="canEdit(user); else lastNameText" [routerLink]="['/app/user', user.id]"
               (click)="setCurrentSelectedUser(user)"><strong>{{ user.lastName }}</strong></a>
            <ng-template #lastNameText><strong>{{ user.lastName }}</strong></ng-template>
          </td>
          <td>
            <a *ngIf="canEdit(user); else firstNameText" [routerLink]="['/app/user', user.id]"
               (click)="setCurrentSelectedUser(user)"><strong>{{ user.firstName }}</strong></a>
            <ng-template #firstNameText><strong>{{ user.firstName }}</strong></ng-template>
          </td>
          <td>{{ user.emailAddress }}</td>
          <td class="hidden-sm-down">{{ formatUserType(userTypeDisplay[user.userType]) }}</td>
          <td class="hidden-sm-down">{{ user.agency?.agencyName }}</td>
          <td class="hidden-sm-down">{{ user.company?.name }}</td>
          <td class="hidden-sm-down">{{ user.status }}</td>
        </tr>
      </table-dynamic>
    </div>
  </div>
  <agency-box (onAgencySelected)="onAgencySelected($event)"></agency-box>
</section>
